import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InsuranceProfession  {
    _originalTypeClassName = "zERP.BO.InsuranceProfession";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InsuranceProfession.translate = translateService;
}
this.Packages = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.FullName = null;
this.SystemOwner = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
FullName:any;
SystemOwner:any;
Description:any;
Packages:any;
static setPackages = ($this, items) => {
                if (items == null) items = [];
                if ($this.Packages == null) $this.Packages = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Packages.length > 0) {
                    Domain.InsuranceProfession.removePackages($this, $this.Packages[0]);
                }

                Domain.InsuranceProfession.addManyPackages($this, copyItems);
            }
static addManyPackages = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InsuranceProfession.addPackages($this, items[i]);
                }
            }
static addPackages = ($this, item) => {
                if ($this.Packages == null) $this.Packages = [];
                if (item == null || $this.Packages.indexOf(item) > -1) return;
                $this.Packages.push(item);
if (item.InsuranceProfession != $this) {
Domain.SICProfessionPackage.setInsuranceProfession(item, $this);
}
}
static addRangePackages = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InsuranceProfession.addPackages($this, item));
            }
static removePackages = ($this, item) => {
                if ($this == null || $this.Packages == null || $this.Packages.indexOf(item) === -1) return;
                var _index = $this.Packages.indexOf(item);
                $this.Packages.splice(_index, 1);
item.InsuranceProfession = null;
}
static clearPackages = ($this) => { $this.Packages = null; }

static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}